import { CreateEditAtlasPayload } from '../interfaces';

export function generateCreateAtlasPayload(atlasName: string, atlasId: string, description: string | null): CreateEditAtlasPayload {
  return {
    data: {
      type: 'atlas',
      attributes: {
        id: atlasId,
        name: atlasName,
        description: description ?? '',
      }
    }
  };
}

export function generateEditAtlasPayload(atlasId: string, atlasName: string, description: string | null): CreateEditAtlasPayload {
  return {
    data: {
      type: 'atlas',
      id: atlasId,
      attributes: {
        name: atlasName,
        description,
      }
    }
  };
}
